var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showHeaderAlert)?_c('global-alert',{attrs:{"content":_vm.alert.content,"type":_vm.alert.type,"closable":_vm.alert.closable,"show-default-icon":_vm.alert.showDefaultIcon,"icon":_vm.alert.icon}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }